<template>
  <setting-layout
    header-title="配置网络"
    footer-text="保存"
    @footer-click="handleSave"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="120px"
      class="network-setting-form"
      :rules="rules"
    >
      <el-form-item
        label="IP地址"
        prop="ip"
      >
        <el-input v-model="form.ip"></el-input>
      </el-form-item>
      <el-form-item
        label="子网掩码"
        prop="netmask"
      >
        <el-input
          v-model="form.netmask"
          placeholder="例如: 24"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="网关"
        prop="gateway"
      >
        <el-input v-model="form.gateway"></el-input>
      </el-form-item>
      <el-form-item
        label="首选DNS"
        prop="dns_servers.0"
      >
        <el-input v-model="form.dns_servers[0]"></el-input>
      </el-form-item>
      <el-form-item
        label="备用DNS"
        prop="dns_servers.1"
      >
        <el-input v-model="form.dns_servers[1]"></el-input>
      </el-form-item>
      <el-form-item label="备用管理IP">
        <span class="readonly-text">192.168.13.37/24 (不可修改，永久有效，用于IP配置错误或遗忘时访问)</span>
      </el-form-item>
    </el-form>
  </setting-layout>
</template>

<script>
import SettingLayout from '@/components/setting-layout.vue';
import { getNetworkSetting, setNetworkSetting } from '@/api/base';

export default {
  name: 'NetworkSetting',
  components: {
    SettingLayout,
  },
  data() {
    return {
      form: {
        ip: '',
        netmask: '',
        gateway: '',
        dns_servers: ['', ''], // [primary, secondary]
      },
      rules: {
        ip: [
          { required: true, message: '请输入IP地址', trigger: 'blur' },
          { validator: this.validateIpAddress, trigger: 'blur' },
        ],
        netmask: [
          { required: true, message: '请输入子网掩码 (CIDR格式, 例如: 24)', trigger: 'blur' },
          { validator: this.validateNetmaskPrefix, trigger: 'blur' },
        ],
        gateway: [
          { required: true, message: '请输入网关地址', trigger: 'blur' },
          { validator: this.validateIpAddress, trigger: 'blur' },
        ],
        'dns_servers.0': [
          { required: true, message: '请输入首选DNS服务器', trigger: 'blur' },
          { validator: this.validateIpAddress, trigger: 'blur' },
        ],
        'dns_servers.1': [
          // Secondary DNS is optional, only validate format if provided
          { validator: this.validateIpAddress, trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    handleSave() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // Implement save logic here
          console.log('Form data:', this.form);
          setNetworkSetting(this.form).then(() => {
            this.$message.success('保存成功');
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    validateIpAddress(rule, value, callback) {
      if (value && !/^((\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.){3}(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/.test(value)) {
        callback(new Error('请输入有效的IP地址'));
      } else {
        callback();
      }
    },
    validateNetmaskPrefix(rule, value, callback) {
      if (!value) {
        // Allows empty for optional fields; 'required' rule handles mandatory check.
        callback();
        return;
      }
      const prefix = Number(value);
      if (Number.isInteger(prefix) && prefix >= 0 && prefix <= 32 && String(prefix) === value) {
        callback();
      } else {
        callback(new Error('请输入有效的CIDR前缀 (0-32之间的整数)'));
      }
    },
  },
  mounted() {
    getNetworkSetting().then((res) => {
      if (res) {
        this.form.ip = res.ip || '';
        this.form.netmask = res.netmask || '';
        this.form.gateway = res.gateway || '';

        const dns1 = res.dns_servers && res.dns_servers.length > 0 ? res.dns_servers[0] : '';
        const dns2 = res.dns_servers && res.dns_servers.length > 1 ? res.dns_servers[1] : '';
        // Ensure reactivity when assigning to array elements if not pre-initialized with correct length,
        // but since dns_servers is initialized as ['', ''], direct assignment or $set is fine.
        this.$set(this.form.dns_servers, 0, dns1);
        this.$set(this.form.dns_servers, 1, dns2);
      }
    });
  },
};
</script>

<style lang="scss">
.network-setting-form {
  max-width: 800px; /* Limit form width for better readability */
  margin: 40px auto 0; /* Center the form */

  .readonly-text {
    color: #606266; /* Standard text color for disabled/readonly elements */
  }

  .el-form-item {
    margin-bottom: 20px;
  }

  .el-form-item__label {
    font-weight: bold;
    text-align: left;
  }
}
</style>
